export default __webpack_public_path__ + "72a0a3ed20f9feadab3cbb56e73744f4.png";